
<template>
  <UIModalController>
    <template #default="{ close }">
      <div class="minwithcontainer pa5">
        <form novalidate @submit.prevent="confirm">
          <UIIcon class="icon center db fill-medium mb5" :name="icon" v-if="icon" />
          <div class="mb5 f-body tc">
            <slot v-bind="{ close }">
              <component v-if="CustomComponent" :is="CustomComponent" />
              <template v-else>
                <h1 class="f-body b">{{ title }}</h1>
                <p class="f-body" v-if="messageHtml" v-html="messageHtml"></p>
                <p class="f-body" v-else>{{ message }}</p>
              </template>
            </slot>
          </div>
          <div class="buttons">
            <UIButton v-if="cancelText" ghost class="w-100" @click="close">{{ cancelText }}</UIButton>
            <UIButton
              :disabled="disabled"
              class="w-100"
              type="submit"
              v-focus.lazy="!disabled"
              v-if="confirmText"
            >{{ confirmText }}</UIButton>
          </div>
        </form>
      </div>
    </template>
  </UIModalController>
</template>

<script>
import UIModalController from '../UIModalController.vue';
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon.vue';
import { focus } from '../../libs/vue-focus.js';

export default {
  name: 'ConfirmModal',
  inject: ['modal'],
  directives: {
    focus,
  },
  props: {
    title: { type: String },
    message: { type: String },
    messageHtml: { type: String },
    render: { type: Function },
    icon: { type: String },
    confirmText: { type: [String, Boolean], default: 'Yes' },
    cancelText: { type: [String, Boolean], default: 'Cancel' },
    args: { type: Object },
    disabled: { type: Boolean },
  },
  components: {
    UIButton,
    UIIcon,
    UIModalController,
  },
  methods: {
    confirm () {
      this.modal.$emit('confirm', this.args);
      this.modal.close();
    },
  },
  computed: {
    CustomComponent () {
      if (!this.render) return;
      return {
        render: this.render,
      };
    },
  },
};
</script>

<style lang="postcss" scoped>
.buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  grid-gap: 2rem;
}
.minwithcontainer {
  min-width: 30rem;
  max-width: 50rem;
}
.icon {
  width: 5rem;
  height: 5rem;
}
</style>
